<template lang="pug">
  v-container(grid-list-xl)
    v-layout(row, wrap)
      v-flex(xs12)
        .text-xs-center
          h3.primary--text Su pedido incluye {{resultados}} libros
          v-btn.green.white--text(depressed, @click="enviarPedido", :disabled="disabled") realizar pedido
          v-btn.red(dark, depressed, @click="limpiar") limpiar pedido
      template(v-for="libro in pedidos")
        v-flex(xs12, sm4, md3)
          v-card
            v-card-text
              v-img.cover(:src="libro.portada || 'http://placehold.it/300x400'", aspect-ratio="0.75", contain)
              h3.mt-2 {{libro.titulo}}
              h4.mb-2 {{libro.autor}}
              v-text-field(label="Cantidad", v-model.number="libro.cantidad", type="number")
              h4(v-if="libro.nuevo") Nuevo
              h4(v-if="libro.usado") Usado
              v-btn(depressed, block, @click="remover(libro.pedido)") remover de pedido
      v-flex(xs12)
        .text-xs-center.mt-2
          v-pagination(v-model="page", :length="paginas")
</template>

<script>
export default {
  data () {
    return {
      page: 1,
      paginacion: 8,
      all: []    
    }
  },
  mounted () {
    this.all = this.$store.getters['cot/todos']
  },
  computed: {
    // all () {
    //   return 
    // },
    pedidos () {
      let inicio = (this.page -1) * this.paginacion
      let termino = inicio + this.paginacion
      return this.all.slice(inicio, termino)
    },
    paginas () {
      return Math.ceil(this.all.length / this.paginacion)
    },
    resultados () {
      return this.all.length
    },
    usuario () {
      return this.$store.getters['usuario/user']
    },
    disabled () {
      if (this.usuario === null || this.all.length === 0)
        return true
      else
        return false
    }
  },
  methods: {
    remover (pedido) {
      this.$store.commit('cot/removerDelPedido', pedido)
      this.all = this.$store.getters['cot/todos']
      this.noted('info', 'Removido del Pedido')
    },
    enviarPedido () {
      this.$store.dispatch('cot/guardarPedido', {user: this.usuario, pedido: this.all})
      .then(() => {
        this.all = []
        this.noted('success', 'Pedido Realizado')
        this.$router.push('/recibido')
      })
    },
    limpiar () {
      this.all = []
      this.$store.commit('cot/setPedido', [])
    }
  }
}
</script>

